import * as React from 'react';
import { Bem, addClass } from '../../utils/css.js';
import { neverDefault } from '../../utils/common.js';
import { useId } from '../../utils/hooks/useId.js';
import './Heading.scss.js';

const { block } = Bem.create("vai-heading");
const Heading = ({ htmlId, className, level, children, dataTa, ...rest }) => {
  const id = useId(htmlId, ["heading"]);
  const elementProps = {
    id: id.toString(),
    className: addClass(block(`level-${level}`), className),
    ["data-ta"]: dataTa,
    ...rest
  };
  switch (level) {
    case "1":
    case 1:
      return /* @__PURE__ */ React.createElement("h1", {
        ...elementProps
      }, children);
    case "2":
    case 2:
      return /* @__PURE__ */ React.createElement("h2", {
        ...elementProps
      }, children);
    case "3":
    case 3:
      return /* @__PURE__ */ React.createElement("h3", {
        ...elementProps
      }, children);
    case "4":
    case 4:
      return /* @__PURE__ */ React.createElement("h4", {
        ...elementProps
      }, children);
    default:
      return neverDefault(level);
  }
};
Heading.defaultProps = {
  level: 1
};

export { Heading };
